export default "__VITE_ASSET__BdnS9KgY__"